import React from "react";
import {
  BaseCard,
  BaseCardBody,
  BaseCardFooter,
  BaseCardImage,
  BaseCardTitle
} from "../BaseCard/BaseCard";
import Skeleton from "react-loading-skeleton";
import styles from "./SuiteCardBase.module.scss";

export const SuiteCardSkeleton: React.FC<React.PropsWithChildren<unknown>> = ({
  children
}) => {
  return (
    <BaseCard background="white" textAlign="center">
      <BaseCardImage ratio="card-compact">
        <Skeleton />
      </BaseCardImage>
      <BaseCardTitle className={styles.title}>
        <Skeleton height={40} />
      </BaseCardTitle>
      <BaseCardBody className={styles.body}>
        <ul className={styles.features}>
          <li>
            <Skeleton count={1} width="80%" />
          </li>
          <li>
            <Skeleton count={1} width="80%" />
          </li>
          <li>
            <Skeleton count={1} width="80%" />
          </li>
        </ul>
        <div className={styles.rightColumn}>{children}</div>
      </BaseCardBody>
      <BaseCardFooter className={styles.footer}>
        <Skeleton count={1} height={44} width={160} />
        <Skeleton count={1} height={44} width={160} />
      </BaseCardFooter>
    </BaseCard>
  );
};
